import { createFileRoute, Link } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { CityPageBody, LocalProofCard } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";
import { ResponsivePicture } from "@/components/site/images";
import { HOMOSASSA_BLUE_METAL_IN_PROGRESS } from "@/components/site/project-images";

export const Route = createFileRoute("/roofing-company-homosassa-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Homosassa, FL | Destination Roofing" },
      { name: "description", content: `Roof repair, replacement, and storm damage repair in Homosassa, FL. Free Roof Inspection & Estimate. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Homosassa, FL" },
      { property: "og:description", content: "Local roofer in Homosassa, FL. Free Roof Inspection & Estimate." },
      { property: "og:url", content: canonical("/roofing-company-homosassa-fl") },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-homosassa-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Homosassa"
      slug="/roofing-company-homosassa-fl"
      localProof={
        <LocalProofCard
          image={HOMOSASSA_BLUE_METAL_IN_PROGRESS}
          alt="Metal roof installation in progress by Destination Roofing in Homosassa Florida"
          town="Homosassa"
          title="Blue metal roof installation in Homosassa, FL"
          to="/projects/blue-metal-roof-homosassa-fl"
        />
      }
      permitNote={
        <p>
          Roof permits for Homosassa homes are handled through the Citrus County Building Division unless the home is inside Crystal River city limits. See our <Link to="/citrus-county-roof-permits">Citrus County roof permit guide</Link>.
        </p>
      }
      intro={
        <p>
          Homosassa homes range from riverfront properties along the Homosassa and Halls Rivers to inland neighborhoods further off the coast. Storm exposure, tree cover, and salt air all play a role in how a roof ages here.
        </p>
      }
      localNotes={
        <>
          <p>
            Along the water we frequently address hardware corrosion, worn flashings, and wind-lifted shingles from the last round of Gulf storms. Inland Homosassa homes see more damage from falling limbs and heavy debris in gutters and valleys.
          </p>
          <p>
            Whether you're dealing with a fresh storm damage roof repair or a slow leak that's finally shown itself on the ceiling, we can be out to inspect it quickly.
          </p>
        </>
      }
      recentProjectSection={
        <>
          <h2>Recent Roofing Work in Homosassa, FL</h2>
          <p>
            Destination Roofing performs roof repairs and full roof replacements throughout Homosassa and the surrounding Citrus County area. This local project shows our crew working on a metal roofing installation in Homosassa. Real project photos help homeowners see the type of roofing work we are actively performing in their community.
          </p>
          <figure className="my-6 rounded-xl overflow-hidden border border-border bg-white not-prose">
            <ResponsivePicture
              image={HOMOSASSA_BLUE_METAL_IN_PROGRESS}
              alt="Metal roof installation in progress by Destination Roofing in Homosassa Florida"
              sizes="(min-width: 1024px) 66vw, 100vw"
              imgClassName="w-full h-auto"
            />
            <figcaption className="p-3 text-sm text-muted-foreground">Metal roofing installation in progress in Homosassa, FL — <Link to="/projects/blue-metal-roof-homosassa-fl">see the project details</Link></figcaption>
          </figure>
          <p>
            Need a <Link to="/roof-inspection">roof inspection</Link> or considering <Link to="/roof-replacement">replacement</Link> in Homosassa? Destination Roofing provides free inspections and installs shingle, <Link to="/metal-roofing">metal</Link> and low-slope roofing systems.
          </p>
        </>
      }
    />
  ),
});
